import React, { Component } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';



//-----------------------------------------------------------------



class Footer extends Component {

  render() {

    const styles = {
      
      footer: {
        padding: 12,
        backgroundColor: "#393939",
      },

    }

    const WhiteTextTypography = withStyles({
      root: {
        color: "#FFFFFF"
      }
    })(Typography);


    return (

      <div>
        <CssBaseline />
        
        <footer style={styles.footer}>
          <Container maxWidth="xl">
            <WhiteTextTypography  variant="body2">Virtual Metrology Frame &copy; 2018 Werkzeugmaschinenlabor WZL</WhiteTextTypography >
          </Container>
        </footer>

      </div>

    );

  }

}


export default Footer;
